import ResetPasswordAckPaper from './ResetPasswordAckPaper';

export default ResetPasswordAckPaper;
